import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_MainPage = _resolveComponent("MainPage")

  return (_openBlock(), _createBlock(_component_MainPage, {
    title: _ctx.$trans('navigation.nav_events'),
    gap: true,
    "disable-animation": _ctx.isReload
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Calendar, {
        year: _ctx.year,
        events: _ctx.events,
        onChangeYear: _ctx.goToYear
      }, null, 8, ["year", "events", "onChangeYear"])
    ]),
    _: 1
  }, 8, ["title", "disable-animation"]))
}